import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
interface ActiveBonusBurst {
  index: number;
  x: number;
  y: number;
}
const BONUS_BURST_DURATION = 780;
const BONUS_BURST_EXIT_DURATION = 180;
const BONUS_BURST_QUEUE_DELAY = 220;
const bonuses = [{
  title: '4 Mentorías grupales- 1 por semanal en vivo',
  description: 'Acompañamiento real para que no te quedes trabado solo.',
  price: 'ARS 468.990',
  image: 'https://cdn.magicpatterns.com/uploads/aoUTPp9FBBEVcvSQSiumnw/Diseno_sin_titulo_(2).png'
}, {
  title: 'Prompts de IA para contenido y anuncios',
  description: 'Para acelerar ideas, copies, hooks y ejecución.',
  price: 'ARS 24.990',
  image: 'https://cdn.magicpatterns.com/uploads/eQLE1BsHgnS72AUgk4XpC8/bono_2.png'
}, {
  title: 'Checklist de lanzamiento',
  description: 'Para que no se te escape ningún paso importante.',
  price: 'ARS 34.990',
  image: 'https://cdn.magicpatterns.com/uploads/pNRpihPYxn1E9ErxUCsMHD/bono.png'
}, {
  title: 'Estructura de Landing Page',
  description: 'Para que puedas armar una página simple y funcional para vender.',
  price: 'ARS 775.000',
  image: 'https://cdn.magicpatterns.com/uploads/bDHdZ9qT59p21m84ykHJcH/bono4.png'
}, {
  title: 'Plantillas de copy para ventas',
  description: 'Para comunicar mejor tu oferta y vender con más claridad.',
  price: 'ARS 29.990',
  image: 'https://cdn.magicpatterns.com/uploads/4KUo9pNbpqkjwPfek3ezN8/bono_5.png'
}];
const TOTAL_SAVINGS_ARS = '1.333.960';
export function BonusesSection() {
  const prefersReducedMotion = useReducedMotion();
  const cardRefs = useRef<(HTMLElement | null)[]>([]);
  const stickerRefs = useRef<(HTMLSpanElement | null)[]>([]);
  const firedBonusIndexes = useRef(new Set<number>());
  const burstQueue = useRef<ActiveBonusBurst[]>([]);
  const isBurstPlaying = useRef(false);
  const [activeBurst, setActiveBurst] = useState<ActiveBonusBurst | null>(null);
  const startNextBurst = () => {
    if (isBurstPlaying.current) return;
    const nextBurst = burstQueue.current.shift();
    if (!nextBurst) return;
    isBurstPlaying.current = true;
    setActiveBurst(nextBurst);
  };
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  useEffect(() => {
    if (prefersReducedMotion) return;
    const observer = new IntersectionObserver(entries => {
      const newlyVisibleBonuses = entries.filter(entry => entry.isIntersecting).map(entry => {
        const index = Number(entry.target.getAttribute('data-bonus-index'));
        return {
          entry,
          index
        };
      }).filter(({
        index
      }) => !firedBonusIndexes.current.has(index)).sort((first, second) => first.index - second.index);
      newlyVisibleBonuses.forEach(({
        entry,
        index
      }) => {
        firedBonusIndexes.current.add(index);
        const sticker = stickerRefs.current[index];
        const {
          left,
          top,
          width,
          height
        } = (sticker ?? entry.target).getBoundingClientRect();
        burstQueue.current.push({
          index,
          x: left + width / 2 - window.innerWidth / 2,
          y: top + height / 2 - window.innerHeight / 2
        });
        observer.unobserve(entry.target);
      });
      startNextBurst();
    }, {
      threshold: 0.45
    });
    cardRefs.current.forEach(card => {
      if (card) observer.observe(card);
    });
    return () => observer.disconnect();
  }, [prefersReducedMotion]);
  useEffect(() => {
    if (!activeBurst) return;
    const clearBurst = window.setTimeout(() => {
      setActiveBurst(null);
    }, BONUS_BURST_DURATION);
    return () => window.clearTimeout(clearBurst);
  }, [activeBurst]);
  useEffect(() => {
    if (activeBurst || !isBurstPlaying.current) return;
    const nextBurst = window.setTimeout(() => {
      isBurstPlaying.current = false;
      startNextBurst();
    }, BONUS_BURST_EXIT_DURATION + BONUS_BURST_QUEUE_DELAY);
    return () => window.clearTimeout(nextBurst);
  }, [activeBurst]);
  return <section id="bonos-de-regalo" className="bg-[#9C16A3] px-4 py-12 md:py-16" data-id="element-27" data-mp="d5508sq15qg7">
      <div className="mx-auto max-w-6xl" data-id="element-28" data-mp="86jy2nr7wwp4">
        <AnimatePresence data-id="element-29" data-mp="85iefuw4z1vs">
          {activeBurst && <motion.div key={activeBurst.index} aria-hidden="true" initial={{
          x: activeBurst.x,
          y: activeBurst.y,
          scale: 0.35,
          opacity: 0
        }} animate={{
          x: 0,
          y: 0,
          scale: [0.35, 1.12, 1],
          opacity: [0, 1, 1]
        }} exit={{
          scale: 1.16,
          opacity: 0,
          transition: {
            duration: BONUS_BURST_EXIT_DURATION / 1000,
            ease: 'easeOut'
          }
        }} transition={{
          duration: BONUS_BURST_DURATION / 1000,
          times: [0, 0.72, 1],
          ease: [0.22, 1, 0.36, 1]
        }} className="pointer-events-none fixed left-1/2 top-1/2 z-[70] -translate-x-1/2 -translate-y-1/2 rounded-full border-4 border-white bg-[#22c55e] px-8 py-4 text-3xl font-black tracking-wide text-black shadow-[0_0_30px_rgba(34,197,94,0.95),0_0_80px_rgba(34,197,94,0.7)] md:px-12 md:py-6 md:text-5xl" data-id="element-30" data-mp="37gtt5j2aui7">
              HOY GRATIS
            </motion.div>}
        </AnimatePresence>
        <header className="mb-12 text-center" data-id="element-31" data-mp="1hdvdqwhvf34u">
          <p className="inline-flex items-center rounded-full border border-yellow-300 bg-yellow-400 px-5 py-2 text-sm font-black tracking-wide text-[#2F0240] shadow-lg md:text-base" data-id="element-32" data-mp="1m5wlc543g5oj">
            BONUS DE REGALO
          </p>
          <h2 className="mt-5 text-4xl font-black leading-tight text-white md:text-5xl" data-id="element-33" data-mp="tp2g8vllon84">
            ACCEDÉ HOY Y LLEVATE LOS 5 BONOS GRATIS
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base font-medium text-purple-100 md:text-lg" data-id="element-34" data-mp="1wyewl416t45h">
            Recursos premium para acelerar tu lanzamiento, incluidos sin costo
            al ingresar a Dominando Shopify.
          </p>
        </header>

        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="21sj69v1u7qa9">
          {bonuses.map((bonus, index) => <article key={bonus.title} ref={element => {
          cardRefs.current[index] = element;
        }} data-bonus-index={index} role="button" tabIndex={0} aria-label={`Ver la compra del Bono ${index + 1}: ${bonus.title}`} onClick={scrollToCompra} onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            scrollToCompra();
          }
        }} className="group cursor-pointer overflow-hidden rounded-2xl border border-white/30 bg-white shadow-xl transition-transform duration-200 hover:-translate-y-1 focus:outline-none focus-visible:ring-4 focus-visible:ring-yellow-300" data-id="element-36" data-mp="1e2fauaysywuc" data-mpi={index}>
              <div className="flex items-center justify-between bg-[#111111] px-4 py-3" data-id="element-37" data-mp="2x0ldxrefu8x3">
                <span className="text-xs font-black tracking-widest text-white" data-id="element-38" data-mp="2x2ejt4h88p41">
                  BONUS {String(index + 1).padStart(2, '0')}
                </span>
                <span ref={element => {
              stickerRefs.current[index] = element;
            }} className="rounded-full bg-[#22c55e] px-3 py-1 text-[11px] font-black tracking-wide text-black animate-[neon-green-glow_1.4s_ease-in-out_infinite]" data-id="element-39" data-mp="3popjmcx0elzs">
                  HOY GRATIS
                </span>
              </div>

              <div className="flex min-h-[250px] items-center justify-center bg-[#171717] px-3 py-4" data-id="element-40" data-mp="cb4bl55y3qf2">
                <img src={bonus.image} alt={`Bono ${index + 1}: ${bonus.title}`} loading="lazy" className="h-auto w-full object-contain" data-id="element-41" data-mp="28f20swa1dlv3" />
              </div>

              <div className="p-6" data-id="element-42" data-mp="1um2jcoqp1hkw">
                <h3 className="text-xl font-black text-gray-950" data-id="element-43" data-mp="1un5bezzr5q2e">
                  Bono {index + 1} — {bonus.title}
                </h3>
                <p className="mt-2 min-h-[48px] text-sm leading-relaxed text-gray-600 md:text-base" data-id="element-44" data-mp="2ra8vrxtuxe9q">
                  {bonus.description}
                </p>
                <div className="mt-5 flex items-center justify-between gap-3 border-t border-gray-200 pt-4" data-id="element-45" data-mp="2ialvxggs0gis">
                  <div data-id="element-46" data-mp="2dbsghihxiffz">
                    <p className="text-xs font-bold uppercase tracking-wide text-gray-500" data-id="element-47" data-mp="2deoet7xov64y">
                      Valor individual
                    </p>
                    <p className="text-lg font-black text-red-600 line-through decoration-2" data-id="element-48" data-mp="11x5djl3o5d91">
                      {bonus.price}
                    </p>
                  </div>
                  <span className="rounded-lg bg-black px-3 py-2 text-sm font-black text-[#22c55e] animate-[neon-green-glow_1.4s_ease-in-out_infinite]" data-id="element-49" data-mp="wsbcv6pkvmgo">
                    HOY GRATIS
                  </span>
                </div>
              </div>
            </article>)}
        </div>

        <section aria-labelledby="ahorro-bonos-title" className="mt-10 overflow-hidden rounded-3xl border border-yellow-300/50 bg-[#0D0D0D] shadow-2xl" data-id="element-50" data-mp="1ak82n43rxk9w">
          <div className="border-b border-white/10 px-6 py-7 text-center md:px-10" data-id="element-51" data-mp="1fkvu1qvx034n">
            <p className="text-sm font-black uppercase tracking-[0.2em] text-[#22c55e]" data-id="element-52" data-mp="1kg2qcdmuu5jj">
              Tu ahorro de hoy
            </p>
            <h3 id="ahorro-bonos-title" className="mt-2 text-2xl font-black text-white md:text-3xl" data-id="element-53" data-mp="3ma20uws5kiv6">
              Todo esto se suma gratis a tu programa
            </h3>
            <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-gray-300 md:text-base" data-id="element-54" data-mp="339nhtaz69f9a">
              Hoy te llevás los 5 bonos gratis con la compra del programa
              completo Dominando Shopify.
            </p>
          </div>

          <ul className="mx-auto max-w-3xl divide-y divide-white/10 px-6 py-4 text-left md:px-10" data-id="element-55" data-mp="3cbof27ueo1ay">
            {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-center justify-between gap-4 py-4" data-id="element-56" data-mp="3m8jbml74brml" data-mpi={index}>
                <span className="text-sm font-bold text-white md:text-base" data-id="element-57" data-mp="3r5005gi8c807">
                  Bono {index + 1} — {bonus.title}
                </span>
                <span className="shrink-0 text-base font-black text-red-500 line-through decoration-2 md:text-lg" data-id="element-58" data-mp="3ua0htejwora">
                  {bonus.price}
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-4 border-t-2 border-white/20 py-5" data-id="element-59" data-mp="dr4z0catqp5k">
              <span className="text-lg font-black text-white md:text-xl" data-id="element-60" data-mp="nw4wela1ksmv">
                VALOR TOTAL
              </span>
              <span className="shrink-0 text-xl font-black text-red-500 line-through decoration-2 md:text-2xl" data-id="element-61" data-mp="iw0gawd1pzx6">
                ARS {TOTAL_SAVINGS_ARS}
              </span>
            </li>
          </ul>

          <div className="border-t border-white/10 px-6 py-8 text-center md:px-10" data-id="element-62" data-mp="9xodzx2thdow">
            <p className="text-sm font-bold uppercase tracking-[0.18em] text-gray-400" data-id="element-63" data-mp="16lba1tvzau1t">
              Con tu compra de hoy
            </p>
            <p className="mt-2 text-4xl font-black text-[#22c55e] drop-shadow-[0_0_18px_rgba(34,197,94,0.65)] md:text-6xl" data-id="element-64" data-mp="11pclo6anhc1e">
              TE LLEVÁS TODO POR $0 ARS
            </p>
            <button type="button" onClick={scrollToCompra} className="mt-6 w-full rounded-xl bg-[#22c55e] px-7 py-4 text-base font-black text-black transition-colors hover:bg-[#4ade80] focus:outline-none focus-visible:ring-4 focus-visible:ring-white md:w-auto" data-id="element-65" data-mp="sug3wpcv6r1x">
              QUIERO LOS 5 BONOS GRATIS
            </button>
          </div>
        </section>
      </div>
    </section>;
}